import { Typography } from '@mui/material';
import { weekday } from '../../../FlightDetailCard';
import format from 'date-fns/format';
import React from 'react';
import * as TFF from '@tff/types/TFF';

interface CostBondRowProps {
  journey: TFF.Journey;
  locale: { locale: string };
}

export const CostBondRow: React.FC<CostBondRowProps> = ({ journey, locale }) => {
  const formatDate = (t: string): string | null => {
    if (t) {
      return format(new Date(t), 'dd.MM.yyyy');
    }
    return null;
  };

  const formatTime = (time: string) => {
    return new Intl.DateTimeFormat('de-DE', { timeStyle: 'short' }).format(new Date(time));
  };

  const firstSegment = journey.Segments[0];
  const lastSegment = journey.Segments[journey.Segments.length - 1];

  const showDepartureWeekAndDate = () => {
    const week = weekday(firstSegment?.DepartureTime, locale.locale).substring(0, 2);
    const departureDate = formatDate(firstSegment?.DepartureTime);

    return `${week}. ${departureDate}`;
  };

  const showDepartureAndArrivalTime = () => {
    const departureTime = formatTime(firstSegment?.DepartureTime);
    const arrivalTime = formatTime(lastSegment?.ArrivalTime);

    return `${departureTime} - ${arrivalTime}`;
  };

  return (
    <div>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {journey.Ond}
      </Typography>
      <Typography variant="body2">
        {showDepartureWeekAndDate()}
        {`  ·  `}
        {showDepartureAndArrivalTime()}
      </Typography>
    </div>
  );
};

export default CostBondRow;
